import React from 'react';
import { Link } from 'react-router-dom';
import { Reveal } from './Reveal';
import { ArrowMark } from './Marks';
const STEPS = [{
  n: '01',
  title: 'Välj vad ni vill bjuda på',
  text: 'Bläddra i utbudet och lägg allt i samma förfrågan — även från olika aktörer.'
}, {
  n: '02',
  title: 'Skicka en förfrågan',
  text: 'Datum, antal och adress. Ni behöver inte kontakta varje ställe själva.'
}, {
  n: '03',
  title: 'Få svar inom 24 timmar',
  text: 'Vi bekräftar med pris och leveranstid. Sedan är det bara att äta.'
}];

/** The promise behind the request flow. Shown at the end of the catering catalogue. */
export function HowItWorks() {
  return <section aria-labelledby="sa-funkar" className="mt-20 bg-blaa text-papper" data-id="element-683" data-mp="gt1o1swo6gp2">
      <div className="mx-auto max-w-page px-5 py-16 md:px-8 md:py-20" data-id="element-684" data-mp="14j5ue818sujr">
        <Reveal data-id="element-685" data-mp="14h1f6txw8946">
          <h2 id="sa-funkar" className="display-xl text-4xl uppercase sm:text-6xl" data-id="element-686" data-mp="14hb9gtpz12fo">
            En förfrågan. Alla aktörer.
          </h2>
          <p className="mt-4 max-w-lg text-lg leading-relaxed text-papper/75" data-id="element-687" data-mp="2rkwauqgt5xj7">
            Ni behöver inte ringa fem ställen. Lägg allt i samma förfrågan så samordnar vi leveransen.
          </p>
        </Reveal>

        <ol className="mt-14 grid gap-10 md:grid-cols-3" data-id="element-688" data-mp="31c96zu9n39v1">
          {STEPS.map((step, i) => <Reveal key={step.n} delay={Math.min(i * 0.06, 0.18)} data-id="element-689" data-mp="2wjz7bmiq2vfk" data-mpi={i}>
              <li className="border-t-2 border-papper/40 pt-5" data-id="element-690" data-mp="3abmh8p5l82gt">
                <span className="display-xl block text-5xl text-smor" data-id="element-691" data-mp="3ae8n8kcty9wx">{step.n}</span>
                <h3 className="mt-3 font-display text-2xl uppercase" data-id="element-692" data-mp="36aaowbvbx34x">{step.title}</h3>
                <p className="mt-2 leading-relaxed text-papper/70" data-id="element-693" data-mp="3k90ihhixwkoj">{step.text}</p>
              </li>
            </Reveal>)}
        </ol>

        <Reveal data-id="element-694" data-mp="1pwas39rs5tlw">
          <Link to="/forfragan" className="group mt-12 inline-flex items-center gap-3 bg-papper px-8 py-4 text-[12px] font-bold uppercase tracking-wide2 text-black transition-colors duration-150 ease-out hover:bg-smor" data-id="element-695" data-mp="1pvsn9or1y72d">
            Se din förfrågan
            <ArrowMark className="h-3.5 w-8 transition-transform duration-200 ease-out group-hover:translate-x-1" data-id="element-696" data-mp="3pyaa54a41ewi" />
          </Link>
        </Reveal>
      </div>
    </section>;
}